<template>
  <a-modal
    :title="language['modal.resetPassword']"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']"
    style="top:20px;"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"
                     prop="applicationId"
          :label="language['premission.applicationName']" >
          <a-select
            style="width: 100%"
            allowClear
            :placeholder="language['premission.mustApplication']"
            :disabled="$store.getters.application.applicationType!== 'platform'"
            v-decorator="[ 'applicationId', validatorRules.applicationId]"
          >
            <a-select-option v-for="(item,index) in application" :key="index.toString()" :value="item.id">
              {{ item.applicationNameLanguage }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :label="language['user.column.password']" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback >
          <a-input type="password" :placeholder="language['common.pleaseInput']+language['user.column.password']" v-decorator="[ 'password', validatorRules.password]" />
        </a-form-item>
        <a-form-item :label="language['column.confirmPassword']" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback >
          <a-input type="password" @blur="handleConfirmBlur" :placeholder="language['warning.passwordAgainRequired']" v-decorator="[ 'confirmpassword', validatorRules.confirmpassword]"/>
        </a-form-item>

        <a-form-model-item :label="language['system.user.name']" prop="usernames" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-textarea :rows="5" :max-length="1000" v-decorator="[ 'usernames', validatorRules.usernames]" :placeholder="language['system.user.passwordBatchTip']" />
        </a-form-model-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {setPasswordBatch} from '@/api/api'
  import { httpAction } from '@/api/manage'

  export default {
    name: "PasswordBatchModal",
    data () {
      return {
        visible: false,
        confirmLoading: false,
        confirmDirty: false,
        validatorRules:{
          password:{
            rules: [{
              required: true,
              pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/,
              message: this.$store.getters.language['warning.passwordConsists']
            }, {
              validator: this.validateToNextPassword,
            }]
          },
          confirmpassword:{
            rules: [{
              required: true, message: this.$store.getters.language['warning.inputpasswordAgain'],
            }, {
              validator: this.compareToFirstPassword,
            }],
          },
          usernames:{
            rules: [{
              required: true,
              message:  this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['system.user.name'],
            }]
          },
         applicationId:{
            rules: [{
              required: true,
              message:  this.$store.getters.language['platform.roleUser.pleaseSetApplication'],
            }]
         },
        },
        application:[{
          id:'',
          applicationName:''
        }],


        model: {},

        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form: this.$form.createForm(this)
      }
    },
    created () {
      this.getSysBmApplication();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      show () {
        this.form.resetFields();
        this.visible = true;
        if(this.$store.getters.application.applicationType!== 'platform'){
          this.model.applicationId = this.$store.getters.application.id;
        }
        /*this.model.username = username;
        this.$nextTick(() => {
          this.form.setFieldsValue({username:username});
        });*/
      },
      getSysBmApplication(){
        httpAction("/sys/role/getSysBmApplicationDL", "", "get").then((res) => {
          if (res.success) {
            this.application = res.result;
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleSubmit () {
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            setPasswordBatch(formData).then((res)=>{
              if(res.success){
                this.$message.success(res.message);
                this.$emit('ok');
              }else{
                this.$message.error(res.message,5);
              }
            }).finally(() => {
              this.confirmLoading = false;
              //this.close();
            });
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateToNextPassword  (rule, value, callback) {
        const form = this.form;
        const confirmpassword=form.getFieldValue('confirmpassword');
        if (value && confirmpassword && value !== confirmpassword) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        }
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }
        callback();
      },
      compareToFirstPassword  (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        } else {
          callback()
        }
      },
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }
    }
  }
</script>